/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ProjectPaymentNotificationsResourceNotificationsInner } from './';
import {
    ProjectPaymentNotificationsResourceNotificationsInnerFromJSON,
    ProjectPaymentNotificationsResourceNotificationsInnerFromJSONTyped,
    ProjectPaymentNotificationsResourceNotificationsInnerToJSON,
} from './';

/**
 * 
 * @export
 * @interface ProjectPaymentNotificationsResource
 */
export interface ProjectPaymentNotificationsResource {
    /**
     * 
     * @type {Array<ProjectPaymentNotificationsResourceNotificationsInner>}
     * @memberof ProjectPaymentNotificationsResource
     */
    notifications: Array<ProjectPaymentNotificationsResourceNotificationsInner>;
}

/**
 * Check if a given object implements the ProjectPaymentNotificationsResource interface.
 */
export function instanceOfProjectPaymentNotificationsResource(value: object): value is ProjectPaymentNotificationsResource {
    if (!('notifications' in value) || value['notifications'] === undefined) return false;
    return true;
}

export function ProjectPaymentNotificationsResourceFromJSON(json: any): ProjectPaymentNotificationsResource {
    return ProjectPaymentNotificationsResourceFromJSONTyped(json, false);
}

export function ProjectPaymentNotificationsResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectPaymentNotificationsResource {
    if (json == null) {
        return json;
    }
    return {
        
        'notifications': ((json['notifications'] as Array<any>).map(ProjectPaymentNotificationsResourceNotificationsInnerFromJSON)),
    };
}

export function ProjectPaymentNotificationsResourceToJSON(value?: ProjectPaymentNotificationsResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'notifications': ((value['notifications'] as Array<any>).map((v) => ProjectPaymentNotificationsResourceNotificationsInnerToJSON(v))),
    };
}

